// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 503) return "static/chunks/503-cbd1dcf83850babf.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"547":"62066e9432db004c","836":"679f2975d32a4fe4"}[chunkId] + ".js";
};